import * as types from '../actions/types'

const initialState = {}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.MAPBOX_DIRECTIONS_RESPONSE:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
